import $ from "jquery";

$(() => {
    const from = $('input[name="caseBean.startDate"]');
    const to = $('input[name="caseBean.endDate"]');
    from.on('change', () => {
        const temp = to.val();
        to.val('');
        to.attr('datePicker') === 'true' ? to.closest('.date-picker').attr('data-min-date', from.val()) : to.prop("min", from.val());
        to.val(temp);
    });
});

